export default "__VITE_ASSET__Bi1sXwzN__"